'use client';

import { useAdvisorHelper } from 'hooks/advisors/useAdvisorHelper';
import CustomLink from 'components/shared/CustomLink';
import styles from './AdvisorSection.module.css';

type Link = {
  href: string;
  title: string;
};

type AdvisorType = {
  title: string;
  subtitle: string;
  links: Link[];
  description: string;
  image: string;
};

export const AdvisorSection = ({
  className,
  advisorId,
}: {
  className?: string;
  advisorId: string;
}) => {
  const advisorData = useAdvisorHelper(advisorId) as AdvisorType;
  return (
    <div className={`${styles.root} u-grid${className ? ` ${className}` : ''}`}>
      <div className={styles.content}>
        <div className={styles['section-1']}>
          <div className={styles.text}>
            <h4>ADVISOR</h4>
            <h1>{advisorData?.title}</h1>
            <h3>{advisorData?.subtitle}</h3>
            <div className={styles['social-btns']}>
              {(
                advisorData?.links as Array<
                  Record<string, React.ReactNode | string>
                >
              ).map((element, index) => {
                return (
                  <CustomLink href={element.href as string} key={index}>
                    {element.title}
                  </CustomLink>
                );
              })}
            </div>
          </div>
          <div className={styles.image}>
            <img
              src={advisorData.image as string}
              alt="Out Board Member"
              loading="eager"
            />
          </div>
        </div>
        <div className={styles['section-2']}>{advisorData?.description}</div>
      </div>
    </div>
  );
};
